/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

const $ = window.jQuery;

$(() => OkNF.init());

window.OkNF = {
	messageClass: "oknf-message",

	// must match css transition time
	messageTransition: 150,

	messageTypes: {
		error: "error",
		success: "success",
	},

	init() {
		if (this.isInitted) {
			return;
		}

		this.listen();
		this.isInitted = true;
	},

	listen() {
		const selects = ".oknf-select";

		// select box focus state
		$("body")
			.on("focus", selects, e => {
				$(e.currentTarget).addClass("focus");
			})
			.on("blur", selects, e => {
				$(e.currentTarget).removeClass("focus");
			})
			// select box change
			.on("change keyup", selects, e => {
				const wrapper = $(e.currentTarget);
				const value = wrapper.find("select option:selected").text();

				wrapper.find(".oknf-select-active").text(value);
			})
	},

	// message interface
	errorMessage(params) {
		if (params == null) {
			params = {};
		}

		if (!params.el) {
			return;
		}

		this._setMessage({
			el: params.el,
			type: this.messageTypes.error,
			message: params.message,
		});
	},

	successMessage(params) {
		if (params == null) {
			params = {};
		}

		if (!params.el) {
			return;
		}

		this._setMessage({
			el: params.el,
			type: this.messageTypes.success,
			message: params.message,
		});
	},

	clearMessage(params) {
		if (params == null) {
			params = {};
		}

		if (!params.el) {
			return;
		}

		this._removeMessageClasses(params.el);

		let nextEl = params.el.next();

		if (nextEl.hasClass(this.messageClass)) {
			nextEl.removeClass(`${this.messageClass}--show`);

			setTimeout(() => {
				nextEl.remove();
			}, this.messageTransition);
		}
	},


	// Private methods
	// ---------------------------------------------------------------------------

	_removeMessageClasses(el) {
		let classesToRemove = [
			`oknf-textarea--${this.messageTypes.error}`,
			`oknf-textarea--${this.messageTypes.success}`,
			`oknf-input--${this.messageTypes.error}`,
			`oknf-input--${this.messageTypes.success}`,
		];

		el.removeClass(classesToRemove.join(" "));
	},

	// helper for error and success message setting
	_setMessage(params) {
		let messageEl;
		let prefix;

		if (!params.type) {
			return;
		}

		this._removeMessageClasses(params.el);

		if (params.el.is("input")) {
			prefix = "oknf-input--";
		} else if (params.el.is("textarea")) {
			prefix = "oknf-textarea--";
		}

		params.el.addClass(`${prefix}${params.type}`);

		if (!params.message) {
			return;
		}

		let nextEl = params.el.next();
		if (nextEl.hasClass(this.messageClass)) {
			messageEl = nextEl;
		} else {
			messageEl = $(`\
<span class="${this.messageClass}">
	${params.message}
</span>\
`);

			params.el.after(messageEl);
		}

		messageEl.css("opacity");

		messageEl
			.removeClass(`${this.messageClass}--${this.messageTypes.error}`)
			.removeClass(`${this.messageClass}--${this.messageTypes.success}`)
			.addClass(`${this.messageClass}--${params.type}`)
			.addClass(`${this.messageClass}--show`)
			.text(params.message);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/native_forms.js